import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import styled from 'foundations-theming/utils';
import { getColorStyleWithOpacity } from 'MeetingsLib/utils/color';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import FreemiumViralTrackingPixel from 'MeetingsLib/tracking/FreemiumViralTrackingPixel';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Styled wrapper to apply custom styling to the SelectableButton
const StyledButtonWrapper = styled.div.withConfig({
  displayName: "FreemiumUpgradeButton__StyledButtonWrapper"
})([">:first-child{max-width:fit-content !important;}", ""], props => props.customStyle && `
      border-color: ${props.customStyle.borderColor || 'inherit'};
      background-color: ${props.customStyle.backgroundColor || 'inherit'};
    `);

// Styled span to apply custom color
const StyledText = styled.span.withConfig({
  displayName: "FreemiumUpgradeButton__StyledText"
})(["color:", ";"], props => props.color || 'inherit');
export default class FreemiumUpgradeButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleTreatmentFetched = () => {
      this.setState({
        treatmentFetched: true
      });
    };
    this.handleViralButtonClick = () => {
      if (this.state.experimentEnabled) {
        track('meetingsLibViralityExperiment', {
          action: 'click',
          variation: this.state.variation
        });
      }
      this.props.handleButtonClick();
    };
    this.getBrandingActiveStyle = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      if (!primaryColor) {
        return null;
      }
      return {
        width: 'auto',
        borderColor: primaryColor,
        backgroundColor: getColorStyleWithOpacity(primaryColor)
      };
    };
    this.getBrandingTextStyle = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      if (!primaryColor) {
        return null;
      }
      return {
        color: primaryColor
      };
    };
  }
  componentDidMount() {
    track('meetingsViralityPageView', {
      action: 'virality-thank-you-page-view'
    });
    this.handleTreatmentFetched();
  }
  render() {
    const {
      handleButtonClick,
      portalId,
      embedded,
      branding: {
        primaryColor
      }
    } = this.props;
    const linkType = 'meetings-thankyou';
    const style = this.getBrandingActiveStyle();
    return (
      /*#__PURE__*/
      /* @bend-expect trellis-tokenized we need to use a wrapper div to apply custom styles */
      _jsx(StyledButtonWrapper, {
        customStyle: style,
        children: /*#__PURE__*/_jsxs(SelectableButton, {
          selected: false,
          onClick: handleButtonClick,
          inlineSize: "700",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: SprocketIcon,
            color: "fill-accent-orange-default",
            marginInlineEnd: "100"
          }), /*#__PURE__*/_jsx(StyledText, {
            color: primaryColor,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "summary.meetingsAdvert.freemium"
            })
          }), portalId > -1 && /*#__PURE__*/_jsx(FreemiumViralTrackingPixel, {
            portalId: portalId,
            embedded: embedded,
            viralLinkType: linkType
          })]
        })
      })
    );
  }
}